import { EventEmitter } from '@angular/core';
import { Script } from '../../../../shared/model/script.model';
import { ScriptService } from '../../../../admin/script/script.service';
import { Router } from "@angular/router";
import { JhiLanguageService } from '../../../../ng-jhipster/language';
import * as i0 from "@angular/core";
import * as i1 from "../../../../admin/script/script.service";
import * as i2 from "@angular/router";
import * as i3 from "../../../../ng-jhipster/language";
import * as i4 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i5 from "@angular/common";
import * as i6 from "@angular/material/form-field";
import * as i7 from "@angular/material/select";
import * as i8 from "@ng-bootstrap/ng-bootstrap";
import * as i9 from "../../../../layouts/navbar/active-menu.directive";
import * as i10 from "@angular/material/core";
import * as i11 from "../../../../shared/auto-direction-switch/auto-direction-switch/auto-direction-switch.component";
import * as i12 from "@ngx-translate/core";
import * as i13 from "../../../../shared/language/find-language-from-key.pipe";
function ScriptsComponent_span_5_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "a", 20);
    i0.ɵɵlistener("click", function ScriptsComponent_span_5_li_5_Template_a_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r6); const language_r4 = restoredCtx.$implicit; const ctx_r5 = i0.ɵɵnextContext(2); return ctx_r5.changeLanguage(language_r4); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "findLanguageFromKey");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const language_r4 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiActiveMenu", language_r4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, language_r4.toLowerCase()));
} }
function ScriptsComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 15);
    i0.ɵɵelementStart(1, "a", 16);
    i0.ɵɵelementStart(2, "span", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "ul", 18);
    i0.ɵɵtemplate(5, ScriptsComponent_span_5_li_5_Template, 4, 4, "li", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.langKeyUppercase);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.languages);
} }
function ScriptsComponent_mat_option_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const category_r7 = ctx.$implicit;
    i0.ɵɵproperty("value", category_r7);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(category_r7);
} }
function ScriptsComponent_div_15__svg_use_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 30);
} }
function ScriptsComponent_div_15__svg_use_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 31);
} }
function ScriptsComponent_div_15_div_8_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "p", 32);
    i0.ɵɵlistener("click", function ScriptsComponent_div_15_div_8_div_1_Template_p_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r16); const s_r14 = restoredCtx.$implicit; const ctx_r15 = i0.ɵɵnextContext(3); return ctx_r15.selectScriptText(s_r14); });
    i0.ɵɵelement(2, "auto-direction-switch", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r14 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", s_r14.type === "tip" ? "tip" : "script");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("innerHtml", s_r14.text, i0.ɵɵsanitizeHtml);
} }
function ScriptsComponent_div_15_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ScriptsComponent_div_15_div_8_div_1_Template, 3, 2, "div", 19);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r12.selectedChapterScripts);
} }
function ScriptsComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 22);
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵelementStart(2, "div", 24);
    i0.ɵɵlistener("click", function ScriptsComponent_div_15_Template_div_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r18); const c_r8 = restoredCtx.$implicit; const i_r9 = restoredCtx.index; const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.selectScriptChapter(c_r8, i_r9); });
    i0.ɵɵelementStart(3, "h5", 25);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(5, "svg", 26);
    i0.ɵɵtemplate(6, ScriptsComponent_div_15__svg_use_6_Template, 1, 0, "use", 27);
    i0.ɵɵtemplate(7, ScriptsComponent_div_15__svg_use_7_Template, 1, 0, "use", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, ScriptsComponent_div_15_div_8_Template, 2, 1, "div", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const c_r8 = ctx.$implicit;
    const i_r9 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", c_r8, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r2.selectedIndex !== i_r9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.selectedIndex === i_r9);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.selectedChapter === c_r8);
} }
export class ScriptsComponent {
    constructor(scriptService, router, languageService) {
        this.scriptService = scriptService;
        this.router = router;
        this.languageService = languageService;
        this.messageSelected = new EventEmitter();
        this.langKey = this.languageService.getCurrentLanguage();
        this.langKeyUppercase = this.langKey === "de" ? "EN" : this.langKey.toUpperCase();
        this.scripts = { EN: new Script()[0], NL: new Script()[0] };
        this.categories = { EN: String[0], NL: String[0] };
        this.languages = ['EN', 'NL'];
    }
    ngOnInit() {
        this.loadScriptsPerLangKey();
    }
    changeLanguage(langKey) {
        this.langKeyUppercase = langKey;
        this.loadScriptsPerLangKey();
    }
    loadScriptsPerLangKey() {
        if (!this.scripts[this.langKeyUppercase] || this.scripts[this.langKeyUppercase].length === 0) {
            this.scriptService.findByLangKey(this.langKeyUppercase).subscribe(res => {
                this.scripts[this.langKeyUppercase] = res.body;
                this.selectedScripts = this.scripts[this.langKeyUppercase];
                this.loadScriptCategories(this.langKeyUppercase);
            });
        }
        else {
            this.selectedScripts = this.scripts[this.langKeyUppercase];
            this.loadScriptCategories(this.langKeyUppercase);
        }
    }
    loadScriptCategories(langKey) {
        this.scriptService.getScriptCategoriesByLangKey(langKey).subscribe(items => {
            this.categories[langKey] = items;
            console.log(this.categories);
            this.selectScriptCategory(this.categories[this.langKeyUppercase][0]);
        });
    }
    selectScriptCategory(category) {
        const categoryScripts = this.selectedScripts.filter(s => s.category === category);
        console.log(this.selectedScripts);
        this.categoryChapters = categoryScripts.map(s => s.chapter).filter((v, i, a) => a.indexOf(v) === i);
        this.selectedCategory = category;
        console.log(this.selectedCategory);
        console.log(this.categoryChapters);
    }
    selectScriptChapter(chapterName, index) {
        if (this.selectedChapter !== chapterName) {
            this.selectedChapter = chapterName;
            this.selectedChapterScripts = this.selectedScripts.filter(s => s.chapter === chapterName);
            this.selectedIndex = index;
        }
        else {
            this.selectedChapter = null;
            this.selectedIndex = null;
        }
    }
    selectScriptText(s) {
        if (s.type !== 'tip') {
            this.message = s.text;
            this.messageSelected.emit({ script: this.message });
        }
    }
}
ScriptsComponent.ɵfac = function ScriptsComponent_Factory(t) { return new (t || ScriptsComponent)(i0.ɵɵdirectiveInject(i1.ScriptService), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i3.JhiLanguageService)); };
ScriptsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ScriptsComponent, selectors: [["scripts-component"]], inputs: { isMobile: "isMobile" }, outputs: { messageSelected: "messageSelected" }, decls: 16, vars: 9, consts: [[1, "olha-theme"], [1, "p-3"], [1, "clearfix"], [1, "d-flex", "justify-content-start", "align-items-center", "dropdown", "d-table"], ["jhiTranslate", "sessionChat.word.script", 1, "script-header"], ["ngbDropdown", "", "class", "d-inline-block text-dark align-middle", 4, "ngIf"], [1, "d-flex"], ["appearance", "outline", "floatLabel", "never", 2, "margin-top", "20px", "flex", "1"], ["jhiTranslate", "sessionChat.word.sessionType"], ["tabindex", "-1", "panelClass", "schedule-session-selectors-dropdown-panel", "disableOptionCentering", "true", 3, "value", "placeholder", "valueChange", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], ["id", "category-select"], [1, "w-100", "d-inline-block"], ["id", "scriptCategories"], ["class", "mb-3 cursor-pointer pr-2", 4, "ngFor", "ngForOf"], ["ngbDropdown", "", 1, "d-inline-block", "text-dark", "align-middle"], ["ngbDropdownToggle", "", "href", "javascript:void(0);", "id", "languagesnavBarDropdown", 1, "language-anchor"], [1, "language-label"], ["ngbDropdownMenu", "", "aria-labelledby", "languagesnavBarDropdown", 1, "dropdown-menu", "dropdown-menu-right", "dropdown-menu-location"], [4, "ngFor", "ngForOf"], ["ngbDropdownItem", "", 1, "language-dropdown-item", 3, "jhiActiveMenu", "click"], [3, "value"], [1, "mb-3", "cursor-pointer", "pr-2"], [1, "position-relative", "px-1", 2, "cursor", "pointer"], [3, "click"], [2, "font-weight", "600", "max-width", "80%"], [1, "angle-icon"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-down", 4, "ngIf"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-up", 4, "ngIf"], [4, "ngIf"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-down"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#angle-up"], [1, "select-text", 3, "ngClass", "click"], [3, "innerHtml"]], template: function ScriptsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelement(4, "h4", 4);
        i0.ɵɵtemplate(5, ScriptsComponent_span_5_Template, 6, 2, "span", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 6);
        i0.ɵɵelementStart(7, "mat-form-field", 7);
        i0.ɵɵelement(8, "mat-label", 8);
        i0.ɵɵelementStart(9, "mat-select", 9);
        i0.ɵɵlistener("valueChange", function ScriptsComponent_Template_mat_select_valueChange_9_listener($event) { return ctx.selectedCategory = $event; })("selectionChange", function ScriptsComponent_Template_mat_select_selectionChange_9_listener() { return ctx.selectScriptCategory(ctx.selectedCategory); });
        i0.ɵɵpipe(10, "translate");
        i0.ɵɵtemplate(11, ScriptsComponent_mat_option_11_Template, 2, 2, "mat-option", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 11);
        i0.ɵɵelementStart(13, "div", 12);
        i0.ɵɵelementStart(14, "div", 13);
        i0.ɵɵtemplate(15, ScriptsComponent_div_15_Template, 9, 4, "div", 14);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.languages && ctx.languages.length > 1);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("value", ctx.selectedCategory)("placeholder", i0.ɵɵpipeBind1(10, 7, "sessionSchedule.header.sessionTypeSelector"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngForOf", ctx.categories[ctx.langKeyUppercase]);
        i0.ɵɵadvance(1);
        i0.ɵɵstyleProp("max-height", ctx.isMobile ? "350px" : "650px");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.categoryChapters);
    } }, directives: [i4.JhiTranslateDirective, i5.NgIf, i6.MatFormField, i6.MatLabel, i7.MatSelect, i5.NgForOf, i8.NgbDropdown, i8.NgbDropdownToggle, i8.NgbDropdownMenu, i8.NgbDropdownItem, i9.ActiveMenuDirective, i10.MatOption, i5.NgClass, i11.AutoDirectionSwitchComponent], pipes: [i12.TranslatePipe, i13.FindLanguageFromKeyPipe], styles: [".script-div[_ngcontent-%COMP%]{padding:30px 0 30px 30px}.script-header[_ngcontent-%COMP%]{padding-right:24px;margin-bottom:0}.angle-icon[_ngcontent-%COMP%]{position:absolute;top:5px !important;right:0 !important;height:12px;width:22px}.tip[_ngcontent-%COMP%]{cursor:default !important}.script[_ngcontent-%COMP%]{background:#fcfbf7;border-radius:5px;cursor:pointer;padding:5px}.in-session-chat[_ngcontent-%COMP%]{position:absolute;right:0;left:0;height:100%;background-color:#f7f7f7}.in-index-coach[_ngcontent-%COMP%]{background-color:#fff}#scriptDropdown[_ngcontent-%COMP%]{color:#44a38d;padding:5px;margin:5px}.dropdown-menu[_ngcontent-%COMP%]{z-index:999;height:auto;max-height:400px;width:auto;overflow:scroll;padding-bottom:0}#script-items[_ngcontent-%COMP%]{list-style-type:none;margin-bottom:0}#category-select[_ngcontent-%COMP%]{overflow-y:scroll;margin-top:20px}.language-anchor[_ngcontent-%COMP%]{text-decoration:none}.language-label[_ngcontent-%COMP%]{line-height:130%;color:#4ab197}.dropdown-menu-location[_ngcontent-%COMP%]{top:0 !important;right:17px !important}a.language-dropdown-item[_ngcontent-%COMP%]{background-color:#fff;color:#44a38d !important}a.language-dropdown-item[_ngcontent-%COMP%]:hover{background-color:#44a38d;color:#fff !important}.select-chapter[_ngcontent-%COMP%]{font-size:12px;font-weight:bold}.select-text[_ngcontent-%COMP%]{white-space:normal;font-size:12px;margin-top:10px;margin-bottom:10px;cursor:pointer}li[_ngcontent-%COMP%]{margin-bottom:.5rem}[_nghost-%COMP%]  .mat-form-field, [_nghost-%COMP%]  .mat-select{font-family:\"Open Sans\",sans-serif !important;font-size:16px !important}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-outline{color:#cce9e0 !important}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-outline-thick{color:var(--main) !important}[_nghost-%COMP%]  .mat-form-field-wrapper{padding-bottom:0}[_nghost-%COMP%]  .mat-form-field-appearance-outline .mat-form-field-infix{padding-top:10px;padding-bottom:10px}"] });
